var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockCircle = function SvgClockCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M32 0C14.328 0 0 14.328 0 32s14.328 32 32 32 32-14.328 32-32S49.672 0 32 0m10.844 42.844c-1.566 1.566-4.168 1.488-5.734-.078l-7.934-7.934a3.9 3.9 0 0 1-.867-1.305A4 4 0 0 1 28 32V16c0-2.211 1.789-4 4-4s4 1.789 4 4v14.344l6.859 6.859a3.977 3.977 0 0 1-.015 5.641"
  })));
};
export default SvgClockCircle;